import { useEffect, useState } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Container } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import HeaderBackground from "../../../common/SubpagesBGimage";
import { useLocation } from "react-router-dom";

const StudentProjects = () => {
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [projectData, setProjectData] = useState(null);

  const location = useLocation();

  const projectFromState = location.state?.project;
  const projectId = location.state?.projectId;

  useEffect(() => {
    if (projectFromState) {
      setProjectData(projectFromState);
      setLoading(false);
    } else if (projectId) {
      fetch("https://psg.mindmadetech.in/admin/api/projects")
        .then((res) => res.json())
        .then((data) => {
          const found = data.projects.find((p) => p.id === projectId);
          setProjectData(found || null);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [projectFromState, projectId]);

  const images = projectData?.images || [];
  const projectname = projectData?.projectname || "";
  const description = projectData?.description || "";

  useEffect(() => {
    if (images.length > 0) {
      Fancybox.bind('[data-fancybox="gallery"]', {});
      return () => Fancybox.destroy();
    }
  }, [images]);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <HeaderBackground
        menuName="Academic Spotlight"
        handleMenuToggle={handleMenuToggle}
      />

      <Container>
        <section className="main-grid">
          <div className="gallery-head">
            {loading ? (
              <div className="loader-container">
                <div className="spinner"></div>
              </div>
            ) : (
              <>
                <h1 className="text-center h1 pb-40 gallery-heading">
                  {projectname}
                </h1>

                <p
                  className="mb-30 ml-20 mr-15 gallery-text"
                  dangerouslySetInnerHTML={{
                    __html: description
                      ?.replace(/\r\n/g, "<br />")
                      .replace(
                        /(Name of the Studio:|Year \/ Semester:|Studio Mentors:|Batch :)/g,
                        "<strong>$1</strong>",
                      ),
                  }}
                ></p>
              </>
            )}
          </div>

          <div className="container">
            {loading ? (
              <Skeleton
                count={5}
                height={200}
                className="mb-4 card-image card"
              />
            ) : images.length > 0 ? (
              images.map((item, index) => (
                <div className="card" key={index}>
                  <div className="card-image">
                    <a
                      href={item.image}
                      data-fancybox="gallery"
                      data-caption={item.content || "Project Image"}
                    >
                      <img src={item.image} alt="Project" />
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No images found for this project.</p>
            )}
          </div>
        </section>
      </Container>
    </div>
  );
};

export default StudentProjects;
